import moment from 'moment'
import {
  momentLocales,
} from '@/utils/language'

// Product decision: Arabic UI shows Western digits (0-9). moment's stock `ar`
// postformat rewrites them to Arabic-Indic, so keep only its comma rewrite.
let arabicUsesWesternDigits = false

const useWesternDigitsForArabic = () => {
  if (arabicUsesWesternDigits) return
  const globalLocale = moment.locale()
  moment.updateLocale('ar', {
    postformat: (formatted) => formatted.replace(/,/g, '،'),
  })
  // updateLocale also switches moment's global locale; only the caller may do that.
  moment.locale(globalLocale)
  arabicUsesWesternDigits = true
}

export const resolveMomentLocaleKey = (payload) => {
  const locale = (payload || 'en').toLowerCase().replace('_', '-')
  if (momentLocales[locale]) return locale
  return Object.keys(momentLocales).find((key) => key.startsWith(locale)) || locale
}

export const getMomentLocale = (payload) => {
  if (!payload) return Promise.resolve()
  const locale = payload.toLowerCase().replace('_', '-')
  const dynamicImport = momentLocales[resolveMomentLocaleKey(payload)]
  return dynamicImport ? dynamicImport().then((localeModule) => {
    if (locale === 'ar') useWesternDigitsForArabic()
    return localeModule
  }).catch((err) => {
    // eslint-disable-next-line no-console
    console.error(`Failed to load moment locale for '${locale}'`, err)
  }) : Promise.resolve()
}
